import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col items-center justify-center" }
const _hoisted_2 = { class: "flex h-24 w-24 items-center justify-center rounded-full bg-primarylighthover" }
const _hoisted_3 = { class: "flex flex-col gap-2 pb-8 pt-4 text-center" }
const _hoisted_4 = { class: "text-lg font-medium" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "flex gap-2 px-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isReassignModalOpened,
    "custom-modal-size": "w-3/12",
    title: _ctx.$t('ICDManagement.ReassignModalHeading'),
    onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-modal'))),
    onExecuteMethod: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('reassign-action')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'triangle-exclamation'],
              class: "text-4xl text-primary"
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("ICDManagement.ReassignModalAlreadyAssigned") + " " + _ctx.customer.name), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("ICDManagement.ReassignModalAreYouSure")) + " tag? ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_the_button, {
            "full-width": true,
            "button-type": "primaryButton",
            text: _ctx.$t('ICDManagement.Reassign'),
            onExecuteMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reassign-action')))
          }, null, 8, ["text"]),
          _createVNode(_component_the_button, {
            "full-width": true,
            "button-type": "oulineButton",
            text: _ctx.$t('General.Cancel'),
            onExecuteMethod: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-modal')))
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-displayed", "title"]))
}